import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class AuthenticateController extends Controller {
  queryParams = ['code'];

  @tracked code;
}
